import React, { useState } from "react";
import styled from "styled-components";

const Tabs = ({
  children,
  titles = ["Médiathèque", "Musée", "Office <br />de tourisme"],
}) => {
  const [active, setActive] = useState(0);
  const childrens = React.Children.toArray(children) || [];

  return (
    <Wrapper>
      <Top>
        {titles &&
          titles.map((item, index) => (
            <a
              key={"tab" + index}
              className={`${active === index ? "active" : ""}`}
              onClick={() => setActive(index)}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
      </Top>
      <Content>{childrens && childrens[active]}</Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 40px;
`;

const Top = styled.div`
  display: flex;

  a {
    flex: 1;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    background-color: #4a4a49;
    height: 50px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &.active {
      background-color: #cdb757;
      color: #171717;
    }

    &:not(:last-child) {
      margin-right: 2px;
    }
  }
`;

const Content = styled.div`
  padding: 40px 24px 20px 24px;
  border: 6px solid #cdb757;
  border-radius: 0 0 32px 0;
`;

export default Tabs;
